import { useMutation } from "@tanstack/react-query";
import toast from "react-hot-toast";
import { useNavigate } from "react-router-dom";

import { resetPassword, sendForgotPasswordEmail } from "@/api";
import { ROUTES } from "@/router";

export const usePasswordRecovery = () => {
  const useSendForgotPasswordEmail = () => {
    return useMutation({
      mutationFn: sendForgotPasswordEmail,
    });
  };

  const useResetPassword = () => {
    const navigate = useNavigate();
    return useMutation({
      mutationFn: resetPassword,
      onSuccess: () => {
        void navigate(ROUTES.login);
        toast.success("Your new password has been set.");
      },
    });
  };

  return {
    useSendForgotPasswordEmail,
    useResetPassword,
  };
};
